import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/common/btn_close.png'


const _hoisted_1 = { class: "title display-y-center display-x-center" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "btn-content" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]

import { currentChannel } from '@/config/config';
import { AlertData } from '@/utils/Define';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import ModalTemplate from '../common/ModalTemplate.vue';
import { showAlert } from '@/utils/function';


    
export default /*@__PURE__*/_defineComponent({
  __name: 'Alert',
  props: {
    // title: {
    //     type: String,
    //     default: "xxxx",
    // },
    // isShowClose: {
    //     type: Boolean,
    //     default: true
    // },
    // isShowHeader: {
    //     type: Boolean,
    //     default: true,
    // },
},
  emits: ["onClose"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
    const store = useStore();
    const alertData = computed(() => {
        return store.state.alertData as AlertData;
    });
    const closeType = ref(0);



const emits = __emit;

function onClickCancel() {
    closeType.value = 1;
    store.state.isShowAlert = false;
    // if (alertData.value.cancelCall) {
    //     alertData.value.cancelCall();
    // }
    // hideAlert();
}

function onClickConfirm() {
    closeType.value = 2;
    store.state.isShowAlert = false;
    // if (alertData.value.confirmCall) {
    //     alertData.value.confirmCall();
    // }
    // hideAlert();
}

function onClickClose() {
    closeType.value = 3;
    store.state.isShowAlert = false;
    // if (alertData.value.closeCall) {
    //     alertData.value.closeCall();
    // }
    // hideAlert();
}

function hideAlert() {
    showAlert(false, <AlertData>{});
}

function handleCloseOver() {
    switch(closeType.value) {
        case 1:
            alertData.value.cancelCall && alertData.value.cancelCall();
            break;
        case 2:
            alertData.value.confirmCall && alertData.value.confirmCall();
            break;
        case 3:
            alertData.value.closeCall && alertData.value.closeCall();
            break;
    }
    hideAlert();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalTemplate, {
    visible: _unref(store).state.isShowAlert,
    onHandleCloseOver: handleCloseOver
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["tip-content", _unref(currentChannel).channel])
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)(alertData.value.title ? alertData.value.title : 'common.1')), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "msg",
            innerHTML: alertData.value.msg
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (alertData.value.btnType == 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "btn-cancel",
                onClick: onClickCancel,
                innerHTML: alertData.value.cancelText ? alertData.value.cancelText : _unref(t)('common.6')
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "btn-confirm",
            onClick: onClickConfirm,
            innerHTML: alertData.value.confirmText ? alertData.value.confirmText : _unref(t)('common.2')
          }, null, 8, _hoisted_6)
        ]),
        (alertData.value.isShowClose)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "btn-close",
              src: _imports_0,
              onClick: onClickClose
            }))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})